import { CLIENTS, CLIENTS_STATEMENT } from "../data/site";
import { Reveal } from "./Reveal";

export default function ClientsGrid() {
  return (
    <div data-testid="clients-grid">
      <p className="mx-auto max-w-2xl text-center text-base md:text-lg text-gig-steel">
        {CLIENTS_STATEMENT}
      </p>
      <div className="mt-10 grid grid-cols-2 gap-px bg-gig-steel/20 sm:grid-cols-3 lg:grid-cols-5 border border-gig-steel/20">
        {CLIENTS.map((client, i) => (
          <Reveal key={client.name} delay={(i % 5) * 0.05} y={16}>
            <div
              className="flex h-24 items-center justify-center bg-white p-4 md:h-28"
              data-testid={`client-${client.logo.split("/").pop().replace(".png", "")}`}
            >
              <img
                src={client.logo}
                alt={`${client.name} — selected project site experience`}
                className="max-h-full max-w-full object-contain"
                loading="lazy"
                width="400"
                height="240"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
